import { Spin as AntdSpin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

const Spin: React.FC = () => {
  return (
    <AntdSpin
      indicator={
        <LoadingOutlined style={{ fontSize: 12, color: '#fff' }} spin />
      }
      style={{ marginRight: 5 }}
    />
  )
}

export default Spin
